export default __webpack_public_path__ + "static/media/Interview-amico.241ff29a.svg";